import React from 'react'
import { Image } from "antd";
import classNames from "classnames";
import MonogramIcon from "assets/images/mongram.jpg";
import { baseImageURL } from "utils/env";
import { useStyles } from './style';

const POSCategoryComponent = ({
    categoryList,
    setCatClick,
    catClick,
    showSideCategories,
    setNewOne,
}: any) => {
    const classes = useStyles();
    return (
        <div className={classNames(classes.categoryWrapper, showSideCategories && classes.activeCategoryWrapper)}>
            <div className="categoryHeader">
                <div className="categoryProfile">
                    <div className="categoryProfileImg">
                        <img src={MonogramIcon} alt="" />
                    </div>
                    <div className="categoryProfileContent">
                        <p className="subInnerHeading">Blockbolt</p>
                        {/* <span className="subHeadingPara">demo@blockbolt.io</span> */}
                    </div>
                </div>
            </div>
            <div className="categoryContent">
                <p className="subHeading">Categories</p>
                <div className="categoryTab">
                    {categoryList && categoryList.map((item: any, index: any) => {
                        return (
                            <div
                                key={index}
                                className={catClick.category_id === item.category_id ? "active categoryTabs" : "categoryTabs"}
                                onClick={() => { setCatClick(item); setNewOne(1); }}
                            >
                                <div className="categoryTabsImg">
                                    <Image src={item.image_path !== null ? `${baseImageURL}${item.image_path}` : MonogramIcon} alt="category image" preview={false} />
                                </div>
                                <p className="subInnerHeading">{item.category_name}</p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    )
}

export default POSCategoryComponent